import styles from './styles.module.css';

export default function HorizontalListItem({ image, onClick}) {
    return <div className={styles.imageStyle} onClick={onClick}>
    <img
        placeholder="blur"
        src={image}
        className={ styles.image }
        alt={image}
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
    />
</div>
}
